<script setup lang="ts">
import { NavigationFailure } from 'vue-router';
import { useRoute, router } from '@hfc/ui-core';
import { UUID } from '@hfc/common/src/types/UUID';
import { AppTypeDentalOrVision } from '@/application/shared/domain/DentalAndVisionApplication';
import { useUrlHelper } from '@/shared/infrastructure/composition/useUrlHelper';
import ChallengeQuestions from '@/shared/infrastructure/components/ChallengeQuestions.vue';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';

const { getRouteNameByAppType } = useUrlHelper();
const route = useRoute();

const props = defineProps<{
  applicationType: AppTypeDentalOrVision;
}>();

const uuid = route.params.uuid as UUID;

const pushRedirect = (): Promise<NavigationFailure | void | undefined> => {
  return router.push({ name: getRouteNameByAppType(props.applicationType, 'ApplicationResume'), params: { uuid } });
};
</script>
<template>
  <div class="py-10">
    <h1 class="text-center">Challenge Questions</h1>
    <p class="text-center text-blue-500">In order to resume your application, please validate the following information from your quote.</p>
  </div>
  <ChallengeQuestions
    :application-type="applicationType"
    :challenge-type="ChallengeType.APPLICATION"
    :uuid="uuid"
    @challenge-success="pushRedirect"
    subtitle=""
    button-text="Resume Application"
    :local-config="{
      zip_code: true,
      date_of_birth: true
    }"
  />
  <div class="flex items-center justify-center md:py-6 lg:py-10">
    <carrier-logo class="w-56 lg:w-72 flex items-center justify-center" :coverage-type="applicationType" carrier-id="blue_shield" vertical="true"
      no-link="true" />
  </div>
</template>
